import { render, staticRenderFns } from "./Moovin.vue?vue&type=template&id=de370890&"
import script from "./Moovin.vue?vue&type=script&lang=js&"
export * from "./Moovin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports